<template>
    <sa-page-layout :btnNewVisible="false" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :linkback="linkback" :showModalLoading="showModalLoading">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovaNotifica">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <!-- <b-form @submit.prevent="onSubmit"> </b-form> -->
        </template>
        <template slot="table-body">
            <notification-notipay-list-component ref="cmpNotificationNotipayList"></notification-notipay-list-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import NotificationNotipayListComponent from "../components/NotificationNotipayListComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    name: "NotificationNotipayListPage",
    components: { SaPageLayout, NotificationNotipayListComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            filtroGestioneOspiti: { nome: null, cognome: null, identificativo: null, idPresidio: null, regime: null, settingCodice: null, idPiano: null },
            btnNewVisible: true,
            btnBackVisible: true,
            linkback: "/home",
            pathResource: "/notificationnotipay",
            linkedit: "",
            showModalLoading: false,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpNotificationNotipayList.loadData(me.filtroGestioneOspiti);
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onClickNuovaNotifica() {
            let me = this;
            me.$refs.cmpNotificationNotipayList.nuovaNotifica();
        },
    },
};
</script>

<style></style>
